module.exports = __webpack_public_path__ + "static/img/newsBg.163eaf76.png";